import { imgToBase64 } from "../../lib/utils/imgToBase64.js";

export default function SingleImageDownloadBtn({
  captureTargetRef,
  captureImage,
  fileName = "무제",
  t,
}) {
  const handleDownloadSingleImg = async () => {
    const imgData = captureImage
      ? await captureImage()
      : (await imgToBase64([captureTargetRef]))[0];
    if (!imgData) return;

    const link = document.createElement("a");
    link.href = imgData;
    link.download = `${fileName}.png`;
    link.click();
  };
  return (
    <button className="btn-bg-blue" onClick={handleDownloadSingleImg}>
      {t}
    </button>
  );
}
